export default {
  //sideSelectType == archives 侧滑的宽度
  archiveSideModalWidth: {
    type: String,
    default: '800',
  },
  parentValue: {
    type: String,
    default: '',
  },
  // detail:详情 select:选择 archives：iscc/财务管理-应付/应收核销款明细表格-‘冲销/核销’列
  sideSelectType: {
    type: String,
    default: 'select',
  },
  //设置为false，组件不可用
  btnDisabled: {
    type: Boolean,
    default: true,
  },
  // 设置为只读
  readonly: {
    type: Boolean,
    default: false,
  },
  //设置为true，组件直接展示侧滑
  showSide: {
    type: Boolean,
    default: false,
  },
  // 侧滑或者弹出窗名称
  modelTitle: {
    type: String,
    default: '查看',
  },
  //侧滑或者弹出窗种表格得列定义url
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  //侧滑或者弹出窗种表格得列定义
  modelTableDef: {
    type: Object,
    default: () => {},
  },
  isValueObject: {
    type: Boolean,
    default: false,
  },
  //变量名
  showParamName: {
    type: String,
    default: 'name',
  },
  //sideSelectType=select时，请求接口得参数
  chooseRequestParam: {
    type: [String, Object],
    default: () => {},
  },
  //sideSelectType=select时， 得数据url
  modelTableDataUrl: {
    type: String,
    default: '',
  },
  //是否在侧滑中展示选中数量
  showSelectItem: {
    type: [Boolean, Object],
    default: false,
  },
  value: {
    type: [Array, String, Number, Object],
    default: () => [],
  },
  //选择侧滑搜索时关键字的属性名
  searchKey: {
    type: String,
  },
  //选择侧滑搜索时placeholder
  placeholder: {
    type: String,
  },
  // 展示搜索框
  showOfSearchInput: {
    type: Boolean,
    default: false,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  queryGroupUrl: {
    type: String,
    default: '',
  },
  selectSerachSideModalWidth: {
    type: String,
    default: '600',
  },
  handleRepeatParam: {
    type: String,
    default: 'id',
  },
  // -----------------20200827 3566 【用户体验优化】物流中心与仓库选择交互模式优化 --------------------------
  isInputSelect: {
    type: Boolean,
    default: false,
  },
  showAllIconSelection: {
    type: Boolean,
    default: true,
  },
  inputSelectShowParam: {
    type: Object,
    default: () => {
      return {
        code: 'code',
        name: 'name',
      }
    },
  },
  inputSelectPost: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'get',
        params: {},
        keywordKey: '',
        topMessage: '',
      }
    },
  },
  needWatchToUpdateFormCreateData: {
    // 用于监听指定字段更新数据
    type: String,
  },
  begFormData: {
    type: Object,
  },
  // 栗子：begFormData:{code1:"1011",code2:"2222"}
  // 此参数为对象：manualUpdateBegFormData:{code1: 'order.code',code2:'order.name'}
  // order.code order.name 为请求返回的数据
  manualUpdateBegFormData: {
    type: Object,
    default: null,
  },
  changeBorthers: {
    type: Object,
    default: null,
  },
  store: Object,
}
